import React, { useEffect, useRef } from "react";
import "./GoogleAds.css";

export default function GoogleAds({
  slot,
  format = "auto",
  responsive = "true",
  style = { display: "block" },
  className = "",
}) {
  const adRef = useRef(null);
  const isInitialized = useRef(false);

  useEffect(() => {
    const initializeAd = () => {
      try {
        if (
          window["adsbygoogle"] &&
          adRef.current &&
          !isInitialized.current &&
          !adRef.current.hasAttribute("data-adsbygoogle-status")
        ) {
          (window["adsbygoogle"] = window["adsbygoogle"] || []).push({});
          isInitialized.current = true;
        }
      } catch (e) {
        console.error("AdSense error:", e);
      }
    };

    const timer = setTimeout(initializeAd, 100);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <div className={`google-ad-container ${className}`}>
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={style}
        data-ad-client="ca-pub-7613903034332644"
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive={responsive}
      ></ins>
    </div>
  );
}
